import { useEffect, useState } from "react";
import { connect } from "react-redux";

import ReactModal from "react-modal";
import { IUserProfile } from "../../models/common/IUserProfile";
import EditProfile from "./components/editProfile";
import { getCurrentUserData } from "../../action/user/userProfileActionCreator";
import { baseURL } from "../../constants/commonConstants";

const AdminSettings = (props: IUserProfile) => {
  const { getUser, user } = props;
  const [showEdit, setShowEdit] = useState(false);

  const handleEditOpen = () => setShowEdit(true)
  const handleEditClose = () => setShowEdit(false)

  const editItem = (id: number) => {
    setShowEdit(true);
    getUser && getUser();
  };

  useEffect(() => {
    if (!user) {
      getUser && getUser();
    }
  }, [getUser, user]);

  return (
    <>
      <div className="card-wrap profilecard">
        <div className="title">
          <h2>Account Settings</h2>
        </div>
        <div className="profile-desc d-flex align-items-center">
          <div className="profile d-flex align-items-center">
            <div className="img">
              <img src={user?.image ? baseURL + user.image : ""}
              onError={(e) => {e.currentTarget.src = "/assets/images/icon/DefaultImage.jpeg"}} />
            </div>
            <div className="desc">
              <h2>{user?.displayName}</h2>
              <p>{user?.email}</p>
            </div>
          </div>
          <div className="btn-flex">
            <button
              className="btn btn-primary"
              data-bs-toggle="modal"
              data-bs-target="#editprofile"
              onClick={() => editItem(1)}
            >
              Edit Profile
            </button>
          </div>
        </div>
      </div>
      <ReactModal
        isOpen={showEdit}
        onRequestClose={handleEditClose}
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
      >
        <EditProfile setShowEdit={handleEditClose} user={user} />
      </ReactModal>
    </>
  );
};

const mapDispatchToProps = {
  getUser: () => getCurrentUserData(),
};

function mapStateToProps(state: any) {
  return {
    user: state.userDetails.userProfileData,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(AdminSettings);
